import { render } from "./FeaturedReleases.vue?vue&type=template&id=1b1ef308"
import script from "./FeaturedReleases.vue?vue&type=script&lang=js"
export * from "./FeaturedReleases.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__